import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CIVILITE } from '../../../constants/referentiel/civilite.enum';
import { ETAPE } from '../../../constants/referentiel/etape.enum';
import { ConventionCollective } from '../../../models/convention-collective.model';
import { Qualification } from '../../../models/qualification.model';
import { LibHttpDemandeService } from '../../../services/provided/lib-http-demande.service';
import { DemandeSharedService } from '../../../services/shared/demande-shared.service';

@Component({
  selector: 'lib-salarie',
  templateUrl: './salarie.component.html',
  styleUrls: ['./salarie.component.scss']
})
export class SalarieComponent implements OnInit {

  public readonly CIVILITE = CIVILITE;
  public readonly TODAY = new Date();

  public form: UntypedFormGroup;
  public parentForm: UntypedFormGroup;
  public listQualification: Qualification[];
  public listConventionCollective: ConventionCollective[];
  public filteredListConventionCollective: Observable<ConventionCollective[]>;
  public isOnBo: boolean;

  constructor(
    private demandeSharedService: DemandeSharedService,
    @Inject('LibHttpDemandeService')
    private demandeService: LibHttpDemandeService,
  ) { }

  ngOnInit(): void {
    this.isOnBo = this.demandeService.isOnBo();
    this.parentForm = this.demandeSharedService.form as UntypedFormGroup;
    this.form = this.parentForm.get('salarie') as UntypedFormGroup;
    this.listQualification = this.demandeSharedService.resolvedData.qualifications;
    this.listConventionCollective = this.demandeSharedService.resolvedData.conventionCollectives;
    this.filteredListConventionCollective = this.salarieConventionCollective.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value)),
    );

    // Fix mat-radio compare with the object's reference, so always use the same object when initiate
    if (this.salarieQualification.value) {
      this.salarieQualification.setValue(
        this.listQualification.find(qualif => qualif.id === this.salarieQualification.value.id));
    }
  }

  /**
   * If demand is closed
   */
  public get isCloture(): boolean {
    if (this.isOnBo) {
      const etapeCtrl = this.parentForm.get('gestion').get('etape') as UntypedFormControl;
      return etapeCtrl && etapeCtrl.value && etapeCtrl.value.code === ETAPE.ETP_CLO_CODE;
    }
    return false;
  }

  /**
   * date range for date picker
   */
  public dateNaissFilter(date: Date): boolean {
    const momentDate = moment(date);
    const momentNow = moment();

    return momentDate.isBefore(momentNow, 'day') && momentDate.isAfter(momentNow.add(-100, 'year'));
  }

  public displayConventionCollective(conventionCollective: ConventionCollective): string {
    if (conventionCollective && conventionCollective.codeIdcc && conventionCollective.intitule) {
      return `${conventionCollective.codeIdcc} - ${conventionCollective.intitule}`;
    }
    return '';
  }

  private _filter(value: any): ConventionCollective[] {
    if (value?.codeIdcc) {
      const filterValue = value.codeIdcc;
      return this.listConventionCollective.filter(
        conventionCollective => conventionCollective.codeIdcc.toLowerCase().includes(filterValue)
      );
    } else if (value) {
      const filterValue = value.toLowerCase();
      return this.listConventionCollective.filter(conventionCollective =>
        conventionCollective.codeIdcc.toLowerCase().includes(filterValue)
        || conventionCollective.intitule.toLowerCase().includes(filterValue)
        || filterValue.includes(conventionCollective.codeIdcc.toLowerCase())
        || filterValue.includes(conventionCollective.intitule.toLowerCase())
      );
    }
    return this.listConventionCollective;
  }

  ///// FORMULAIRE - GETTERS
  public get salarieCivilite(): UntypedFormControl { return this.form.get('civilite') as UntypedFormControl; }
  public get salarieNom(): UntypedFormControl { return this.form.get('nom') as UntypedFormControl; }
  public get salariePrenom(): UntypedFormControl { return this.form.get('prenom') as UntypedFormControl; }
  public get salarieDateNaissance(): UntypedFormControl { return this.form.get('dateNaissance') as UntypedFormControl; }
  public get adresse(): UntypedFormGroup { return this.form.get('adresse') as UntypedFormGroup; }
  public get salarieTelephone(): UntypedFormControl { return this.form.get('telephone') as UntypedFormControl; }
  public get salarieCourriel(): UntypedFormControl { return this.form.get('courriel') as UntypedFormControl; }
  public get salarieQualification(): UntypedFormControl { return this.form.get('qualification') as UntypedFormControl; }
  public get salarieEmploi(): UntypedFormControl { return this.form.get('emploi') as UntypedFormControl; }
  public get salarieConventionCollective(): UntypedFormControl { return this.form.get('conventionCollective') as UntypedFormControl; }
}
